app.service('utilsService', [function () {
    this.debounce = function (func, wait, immediate) {
        if (!func || func.constructor !== Function) {
            throw new Error('utilsService::debounce - first parameter must be a function');
        }
        wait = wait || 300;
        immediate = immediate || false;
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    };
    this.values = function (obj) {
        if (obj.constructor !== Object) {
            return obj;
        }
        var vals = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                vals.push(obj[key]);
            }
        }
        return vals;
    };

    this.first = function (arr) {
        if (!Array.isArray(arr)) {
            return arr;
        }
        return arr[0] || null;
    };

    this.last = function (arr) {
        if (!Array.isArray(arr)) {
            return arr;
        }
        return arr[arr.length - 1];
    };

    this.valueAt = function (arr, position) {
        position = position || 0;
        if (!Array.isArray(arr)) {
            return arr;
        }
        if (position < 0) {
            return arr[arr.length - position];
        }
        return arr[position];
    };

    this.isSet = function (value) {
        return Boolean(angular.isDefined(value) && value !== null);
    };

    this.isEmpty = function (value) {
        if (!this.isSet(value)) {
            return true;
        }

        if (typeof value === 'boolean') {
            return !value;
        }

        if (typeof value === 'number') {
            return value === 0;
        }

        if (value.constructor === String || Array.isArray(value)) {
            return value.length === 0;
        }

        if (value.constructor === Object) {
            return Object.keys(value).length === 0;
        }

        return true;
    };

    this.isNotEmpty = function (value) {
        return !this.isEmpty(value);
    };
}]);
